import { useNavigate } from "react-router-dom";
import type { DuplicatePhotoInfo } from "../../types/api";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

interface DuplicatePhotosDialogProps {
  duplicates: DuplicatePhotoInfo[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DuplicatePhotosDialog({ duplicates, open, onOpenChange }: DuplicatePhotosDialogProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {duplicates.length} duplicate{duplicates.length !== 1 ? "s" : ""} skipped
          </DialogTitle>
          <DialogDescription>
            These photos already exist in AssetFlow and were not uploaded again.
          </DialogDescription>
        </DialogHeader>

        <div className="max-h-[300px] overflow-y-auto space-y-2">
          {duplicates.map((d, i) => (
            <div key={i} className="flex items-center gap-3 rounded-md border p-2 min-w-0 overflow-hidden">
              <img
                src={d.existingPhotoUrl}
                alt={d.uploadedFilename}
                className="h-16 w-16 rounded object-cover flex-shrink-0"
              />
              <div className="min-w-0 flex-1">
                <p className="text-sm truncate" title={d.uploadedFilename}>
                  {d.uploadedFilename}
                </p>
                <button
                  type="button"
                  className="text-sm text-primary hover:underline truncate block"
                  onClick={() => {
                    onOpenChange(false);
                    navigate(`/assets/${d.existingAssetId}`);
                  }}
                >
                  {d.existingAssetNickname}
                </button>
              </div>
            </div>
          ))}
        </div>

        <DialogFooter showCloseButton />
      </DialogContent>
    </Dialog>
  );
}
